import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import withClientGeoLocation from 'components/common/hoc/withClientGeoLocation'
import withType from 'components/common/hoc/withType'
import { getStoreLocatorState } from '../../selectors'
import * as actions from '../../actions'
import StoreLocatorSearchMain from './StoreLocatorSearchMain'

const withCleanSearchMask = lifecycle({
  componentWillUnmount() {
    this.props.resetSearchMask()
    this.props.resetErrorAction()
  }
})

export default compose(
  withType({ type: 'BOTStoreLocatorSearchMain' }),
  connect(getStoreLocatorState, actions),
  withClientGeoLocation,
  withCleanSearchMask
)(StoreLocatorSearchMain)
